import { takeLatest, call, put } from "redux-saga/effects";
import { REGION_ADD_REQUEST } from "../../actions/regions";
import addRegion from "../../../../../backend/oncall/partners/regions/add";
import { push } from "react-router-redux/actions";
import { regionAddError } from "../../actions/regions";

const requestAdd = function*(action) {
  try {
    const result = yield call(
      addRegion,
      action.payload.formData.name,
      action.payload.formData.administrative,
      action.payload.formData.defaultShiftChangeTime,
      action.payload.formData.enabled,
      action.payload.formData.timeZone,
      parseInt(action.payload.formData.defaultShiftDays, 10),
    );
    yield put(push(`/region/edit/${result.id}`));
  } catch (error) {
    yield put(regionAddError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(REGION_ADD_REQUEST, requestAdd);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/regions/request-add.js